// Interface for conversion options (used for Decipher XML, HTML, Word exports, and preview)
export interface ConversionOptions {
  filename?: string // Optional (not needed for preview)
  variant?: string
  languages?: string | string[] // Supports both single string and array
  notes?: string[] // Note types to include (for preview)
  "xml-notes"?: string
  "qnr-notes"?: string
  "variable-names"?: EXPORT_VARIABLE_TYPES
  [key: string]: unknown // Allow additional properties
}

export enum EXPORT_VARIABLE_TYPES {
  NUMBERING = "numbering",
  LABELS = "labels",
}

export enum VARIABLE_STYLE {
  DEFAULT = "default",
  DECIPHER = "decipher",
  CONFIRMIT = "confirmit",
}

export enum EXPORT_FORMAT {
  SPS = "sps",
  SAV = "sav",
  CSV = "csv",
}

export enum SPS_EXPORT_TYPE {
  SPS = "sps",
  DAT = "dat",
  SPS_DAT = "sps_dat",
}

export enum SQL_EXPORT_TYPES {
  WIDE = "wide",
  NARROW = "narrow",
}

// Data format for JSON and DQD exports
export enum DATA_FORMAT {
  CATEGORIZED = "categorized",
  EXPANDED = "expanded",
}

// JSONL flat export separator options
export enum JSONL_FLAT_SEPARATOR {
  NONE = "",         // hierarchical (no flat)
  DSLASH = "dslash", // " // " separator (default flat)
  PIPE = "pipe",     // " | " separator
  DASH = "dash",     // " - " separator
}

// Categorical export options for CSV exports
export enum CSV_CAT_OPTION {
  NORMAL = "cat_normal", // Category codes only, separate map file needed
  EXPAND = "cat_expand", // Creates boolean columns per category
  SECOND_ROW = "cat_second_row", // Category definitions in second row of CSV
  LABELS_IN_DATA = "cat_labels_in_data", // Human-readable labels in data cells
}

export type ConversionType = "word" | "html"

/**
 * Interface for SPSS form values
 */
export interface SPSSFormValues {
  variableType: EXPORT_VARIABLE_TYPES
}

export interface CSVFormValues {
  variableType: EXPORT_VARIABLE_TYPES
}

export interface SQLFormValues {
  sqlType: SQL_EXPORT_TYPES
  projectName: string
}
